import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const AssistantModule = React.lazy(() => import("./AssistantModule"));
const AssistantPage = React.lazy(() => import("./pages/AssistantPage/AssistantPage"));

export const AssistantModuleRoutes: RouteObject = {
  path: ":clientId/assistant",
  element: (
    <ModuleRoute
      El={AssistantModule}
      moduleName="assistant"
      inPolicy={"TeamViewer"}
      ff={"Assistant"}
      blockWhenChurned
    />
  ),
  children: [
    { index: true, element: <PageRoute El={AssistantPage} /> },
    { path: ":threadId", element: <PageRoute El={AssistantPage} /> },
  ],
};
